import type { ImgHTMLAttributes } from 'react';

import { BRAND_ASSET, BRAND_ASSET_SIZE } from '@shared/assets';
import { cn } from '@shared/lib/cn';

import { BRAND_LOGO_TEXT } from './brand-logo.text';

export interface BrandLogoProps extends Omit<
  ImgHTMLAttributes<HTMLImageElement>,
  'src' | 'width' | 'height' | 'alt'
> {
  /** 폭(px). 높이는 원본 비율(182:36)로 정한다. 기본 182(원본 · GlobalHeader) */
  width?: number;
  /** 대체 글. 기본 "D3". 링크 · 버튼 이름과 겹치는 장식 자리는 `""` */
  alt?: string;
}

const { width: LOGO_W, height: LOGO_H } = BRAND_ASSET_SIZE.logo;

/**
 * 서비스 로고(Figma `Brand/Logo` 2269:37). 원본 브랜드 색 그대로(토큰 예외 — design.md).
 * 크기는 폭만 정하고 비율은 고정한다.
 */
export function BrandLogo({
  width = LOGO_W,
  alt = BRAND_LOGO_TEXT.alt,
  className,
  style,
  ...rest
}: BrandLogoProps) {
  return (
    <img
      data-slot="brand-logo"
      src={BRAND_ASSET.logo}
      alt={alt}
      width={width}
      height={Math.round((width * LOGO_H) / LOGO_W)}
      draggable={false}
      {...rest}
      style={{ width, height: 'auto', aspectRatio: `${LOGO_W} / ${LOGO_H}`, ...style }}
      className={cn('block shrink-0 select-none', className)}
    />
  );
}
